<template>
    <entity-editor entity="monster" :id="id" :new-entity="newMonster" :copy="copy" @isDirtyChange="handleIsDirtyChange">
        <template v-slot:[`editor`]="{ doc }">
            <v-row>
                <v-col cols="12" md="9">
                    <v-text-field v-model="doc.name" :rules="[requiredRule]">
                        <template v-slot:[`label`]>
                            <label-required name="Name" />
                        </template>
                    </v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-text-field v-model="doc.section" :rules="[requiredRule]">
                        <template v-slot:[`label`]>
                            <label-required name="Section" />
                        </template>
                    </v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="4">
                    <!-- <v-select
                        v-model="doc.race"
                        :rules="[requiredRule]"
                        :items="races"
                        :disabled="isLoading"
                        label="Race"
                        outlined
                        dense
                        return-object
                        @change="raceChange(doc, $event)"
                    >
                        <template v-slot:[`label`]>
                            <label-required name="Race" />
                        </template>
                    </v-select> -->
                    <v-combobox
                        v-model="doc.race"
                        :items="races"
                        clearable
                        :rules="[requiredRule]"
                        label="Race"
                        outlined
                        dense
                        @change="raceChange(doc)"
                    >
                        <!-- <template v-slot:selection="{ attrs, item, select, selected }">
                            <v-chip
                                v-bind="attrs"
                                :input-value="selected"
                                close
                                @click="select"
                                @click:close="doc.race = null"
                            >
                                <strong>{{ item }}</strong>
                            </v-chip>
                        </template> -->
                    </v-combobox>
                </v-col>
                <v-col cols="12" sm="8">
                    <!-- <v-card elevation="0" outlined>
                        <div><span class="font-weight-medium">Elemental Weakness</span>{{ doc.weakness }}</div>
                    </v-card> -->
                    <v-text-field
                        v-model="doc.elementalWeakness"
                        label="Elemental Weakness"
                        dense
                        readonly
                        outlined
                        filled
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="4">
                    <v-select
                        v-model="doc.patternType"
                        :rules="[requiredRule]"
                        :items="patternTypes"
                        :disabled="isLoading"
                        label="Pattern Type"
                        outlined
                        dense
                        return-object
                        @change="patternChange(doc, $event)"
                    >
                        <template v-slot:[`label`]>
                            <label-required name="Pattern Type" />
                        </template>
                    </v-select>
                </v-col>
                <v-col cols="12" sm="8">
                    <v-textarea
                        v-model="doc.patternTypeEffect"
                        label="Pattern Type Effect"
                        dense
                        return-object
                        readonly
                        rows="2"
                        outlined
                        auto-grow
                        filled
                    ></v-textarea>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="4">
                    <v-select
                        v-model="doc.intelligence"
                        :rules="[requiredRule]"
                        :items="intelligence"
                        :disabled="isLoading"
                        label="Intelligence"
                        outlined
                        dense
                        return-object
                        @change="intelligenceChange(doc, $event)"
                    >
                        <template v-slot:[`label`]>
                            <label-required name="Intelligence" />
                        </template>
                    </v-select>
                </v-col>
                <v-col cols="12" sm="8">
                    <v-textarea
                        v-model="doc.intelligenceEffect"
                        label="Intelligence"
                        dense
                        readonly
                        rows="2"
                        outlined
                        auto-grow
                        filled
                    ></v-textarea>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="6">
                    <v-text-field v-model="doc.hits" label="Hits" :rules="[requiredRule]">
                        <template v-slot:[`label`]>
                            <label-required name="Hits" />
                        </template>
                    </v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                    <v-text-field v-model="doc.armour" label="Armour">
                        <template v-slot:[`label`]>
                            <label-required name="Armour" />
                        </template>
                    </v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-text-field v-model="doc.dismissControl" label="Dismiss/Control"></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-textarea v-model="doc.immunities" label="Immunities" rows="2" outlined auto-grow></v-textarea>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-textarea v-model="doc.strikesFor" label="Strikes For" rows="2" outlined auto-grow></v-textarea>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-textarea
                        v-model="doc.summoningAbility"
                        label="Summoning Ability"
                        rows="2"
                        outlined
                        auto-grow
                    ></v-textarea>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-textarea v-model="doc.abilityOne" label="Ability One" rows="2" outlined auto-grow></v-textarea>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-text-field v-model="doc.abilityTwo" label="Ability Two" outlined></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-textarea
                        v-model="doc.abilityThree"
                        label="Ability Three"
                        rows="2"
                        outlined
                        auto-grow
                    ></v-textarea>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-textarea
                        v-model="doc.restrictionsAndNotes"
                        label="Notes"
                        rows="2"
                        outlined
                        auto-grow
                    ></v-textarea>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-textarea
                        v-model="doc.roleplayGuidelines"
                        label="Roleplay Guidelines"
                        rows="2"
                        outlined
                        auto-grow
                    ></v-textarea>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-textarea v-model="doc.makeupNotes" label="Makeup Notes" rows="2" outlined auto-grow></v-textarea>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-textarea v-model="doc.upstats" label="Upstats" rows="2" outlined auto-grow></v-textarea>
                </v-col>
            </v-row>
        </template>
    </entity-editor>
</template>
<script>
import navGuardConfirmMixin from '../../mixins/navGuardConfirmMixin'
import editorMixin from '../../mixins/editorMixin'
import RequiresLabel from '../../components/RequiredLabel'
import { isString } from 'lodash'
export default {
    name: 'MonsterEditor',
    mixins: [navGuardConfirmMixin, editorMixin],
    components: {
        'label-required': RequiresLabel,
    },
    props: {
        id: {
            type: [Number, String],
            required: false,
            validator: value => {
                return !!value
            },
        },
        copy: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            races: [
                { text: 'None', value: 'None', weakness: 'None' },
                { text: 'Any', value: 'Any', weakness: 'Depends on Race' },
                { text: 'Human', value: 'Human', weakness: 'Flame' },
                { text: 'Beast', value: 'Beast', weakness: 'Air' },
                { text: 'Plant', value: 'Plant', weakness: 'Water' },
                { text: 'Mineral', value: 'Mineral', weakness: 'Earth' },
                { text: 'Dwarf', value: 'Dwarf', weakness: 'Earth' },
                { text: 'Elf', value: 'Elf', weakness: 'Flame' },
                { text: 'Fey', value: 'Fey', weakness: 'Water' },
                { text: 'Olog', value: 'Olog', weakness: 'Air' },
                { text: 'Beastkin', value: 'Beastkin', weakness: 'Air' },
                { text: 'Drow', value: 'Drow', weakness: 'Flame' },
                { text: 'Halfling', value: 'Halfling', weakness: 'Water' },
                { text: 'Uruk', value: 'Uruk', weakness: 'Earth' },
                { text: 'Ancestral', value: 'Ancestral', weakness: 'Water' },
                { text: 'Daemon', value: 'Daemon', weakness: 'Air' },
                { text: 'Elemental', value: 'Elemental', weakness: 'Earth' },
                { text: 'Umbral', value: 'Umbral', weakness: 'Flame' },
                { text: 'Alien', value: 'Alien', weakness: 'Natural' },
            ],
            patternTypes: [
                {
                    text: 'Alien',
                    value: 'Alien',
                    effect: 'Immune to: RoP; Cure Effects (except Full Cure and Total Heal); Normal Poisons',
                },
                { text: 'Living', value: 'Living', effect: 'None' },
                {
                    text: 'Living Aberrant',
                    value: 'Living Aberrant',
                    effect: 'Immune to: RoP; Cure Effects (except Full Cure and Total Heal); Wasting',
                },
                {
                    text: 'Magical',
                    value: 'Magical',
                    effect: 'Immune to: RoP; Decay; Disease; Fatal; Normal Poisons; Paralysis; Sanctuary; Wasting',
                },
                {
                    text: 'Magical Aberrant',
                    value: 'Magical Aberrant',
                    effect:
                        'Immune to: RoP; Cure Effects (except Full Cure and Total Heal); Decay; Disease; Fatal; Normal Poisons; Paralysis; Sanctuary; Wasting',
                },
                { text: 'None', value: 'None', effect: 'None' },
                {
                    text: 'Unliving',
                    value: 'Unliving',
                    effect: 'Immune to: RoP; Decay; Disease; Fatal; Normal Poisons; Paralysis; Sanctuary; Wasting',
                },
                {
                    text: 'Unliving Aberrant',
                    value: 'Unliving Aberrant',
                    effect:
                        'Immune to: RoP; Cure Effects (except Full Repair); Decay; Disease; Fatal; Normal Poisons; Paralysis; Sanctuary; Wasting',
                },
            ],
            intelligence: [
                { text: 'Fully Intelligent', value: 'Fully Intelligent', effect: 'None' },
                { text: 'Instinctive', value: 'Instinctive', effect: 'Immune to: RoP' },
                {
                    text: 'Non-Intelligent',
                    value: 'Non-Intelligent',
                    effect: 'May only have one Active and one Passive instruction, Immune to: RoP; Mind Effects',
                },
            ],
        }
    },
    computed: {
        canSetMonsterManual() {
            return true
        },
        userPermission() {
            if (this.user && this.user[this.entity]) {
                if (this.isNew) {
                    return this.user[this.entity].owned
                } else if (this.doc && this.doc.teamId) {
                    return this.user.teams.includes(this.doc.teamId)
                        ? this.user[this.entity].owned
                        : this.user[this.entity].shared
                }
                return 0
            } else {
                return 0
            }
        },
        weaknesses() {
            return this.races.map(x => x.weakness)
        },
    },
    methods: {
        newMonster() {
            return {
                characterName: '',
                playerName: '',
                notes: '',
                reference: '',
                teamId: null,
                topic: '',
                url: '',
            }
        },
        raceChange(doc) {
            let raceName = isString(doc.race) ? doc.race : isString(doc.race.value) ? doc.race.value : null
            if (!raceName) return
            doc.race = raceName
            let knownRace = this.races.find(x => x.value === raceName || raceName.startsWith(x.value))
            if (!knownRace) return
            doc.elementalWeakness = knownRace.weakness
        },
        patternChange(doc, e) {
            doc.patternTypeEffect = e.effect
            doc.patternType = e.value
        },
        intelligenceChange(doc, e) {
            doc.intelligenceEffect = e.effect
            doc.intelligence = e.value
        },
    },
}
</script>
<style scoped>
.autofill {
    background: lightblue;
}
</style>
